import { withTimeout } from '../../core/utils/timeout';

/** Workspace/read callables: fail-open the shell instead of the SDK ~70s hang. */
export const CALLABLE_TIMEOUT_MS = 15_000;
/** Mutations: stay under the callable server budget without racing the offline queue. */
export const MUTATION_CALLABLE_TIMEOUT_MS = 60_000;

const GATE_CALLABLES = new Set([
  'health',
  'getBillingOverview',
  'getGodOnboarding',
  'getEmailMfaStatus',
  'resolveLoginEmail',
  'checkUsernameAvailable',
  'syncRegisteredProfile',
  'assertDeviceSession',
]);

export function timeoutMsForCallable(name: string): number {
  return GATE_CALLABLES.has(name) ? CALLABLE_TIMEOUT_MS : MUTATION_CALLABLE_TIMEOUT_MS;
}

export function invokeWithCallableTimeout<T>(
  work: Promise<T>,
  ms = CALLABLE_TIMEOUT_MS,
): Promise<T> {
  return withTimeout(work, ms, 'callable-timeout');
}
